unit UWaitingModel;

interface

uses
  UEssentialHelper, WebLib.JSON, Js, UStampModel, UPictureModel;

type
  TWaitingModel = class
  private
    FModelKind: TModelKind;
    FJobKind: TJobKind;
    FValue: string;
    FCreated: TDateTime;
    FTitel: string;
    FSended: TDateTime;
    FArt: string;
    procedure ClearValues;
    procedure SetValues(JSON: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetModelKind(const Value: TModelKind);
    procedure SetJobKind(const Value: TJobKind);
    procedure SetValue(const Value: string);
    procedure SetCreated(const Value: TDateTime);
    procedure SetTitel(const Value: string);
    procedure SetArt(const Value: string);
    procedure SetSended(const Value: TDateTime);
  public
    constructor Create; overload;
    constructor Create(JSON: string); overload;
    constructor Create(Model: TStampModel; JobKind: TJobKind;
      Sended: TDateTime = 0); overload;
    constructor Create(Model: TPictureModel; JobKind: TJobKind;
      Sended: TDateTime = 0); overload;
    function ToPictureModel: TPictureModel;
    function ToStampModel: TStampModel;
    function ToJson: string;
    property ModelKind: TModelKind read FModelKind write SetModelKind;
    property JobKind: TJobKind read FJobKind write SetJobKind;
    property Value: string read FValue write SetValue;
    property Created: TDateTime read FCreated write SetCreated;
    property Titel: string read FTitel write SetTitel;
    property Art: string read FArt write SetArt;
    property Sended: TDateTime read FSended write SetSended;
  end;

implementation

uses
  System.SysUtils;

{ TWaitingModel }

procedure TWaitingModel.ClearValues;
begin
  Self.ModelKind := mkUnknown;
  Self.JobKind := jkUnknown;
  Self.Value := '';
  Self.Created := now;
  Self.Titel := '';
  Self.Art := '';
  Self.Sended := 0;
end;

constructor TWaitingModel.Create;
begin
  Self.ClearValues;
end;

constructor TWaitingModel.Create(JSON: string);
begin
  Self.SetValues(JSON);
end;

constructor TWaitingModel.Create(Model: TStampModel; JobKind: TJobKind;
  Sended: TDateTime = 0);
begin
  Self.ClearValues;
  Self.ModelKind := mkStamp;
  Self.JobKind := JobKind;
  Self.Value := Model.ToJson;
  Self.Created := now;
  Self.Titel := Model.ToString;
  Self.Art := Model.Art;
  Self.Sended := Sended;
end;

procedure TWaitingModel.SetArt(const Value: string);
begin
  FArt := Value;
end;

procedure TWaitingModel.SetCreated(const Value: TDateTime);
begin
  FCreated := Value;
end;

procedure TWaitingModel.SetJobKind(const Value: TJobKind);
begin
  FJobKind := Value;
end;

procedure TWaitingModel.SetModelKind(const Value: TModelKind);
begin
  FModelKind := Value;
end;

procedure TWaitingModel.SetSended(const Value: TDateTime);
begin
  FSended := Value;
end;

procedure TWaitingModel.SetTitel(const Value: string);
begin
  FTitel := Value;
end;

procedure TWaitingModel.SetValue(const Value: string);
begin
  FValue := Value;
end;

procedure TWaitingModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['ModelKind'] <> nil then
    Self.ModelKind := StrToModelKind(string(Obj['ModelKind']));
  if Obj['JobKind'] <> nil then
    Self.JobKind := StrToJobKind(string(Obj['JobKind']));
  if Obj['Value'] <> nil then
    Self.Value := string(Obj['Value']);
  if Obj['Created'] <> nil then
    Self.Created := StrToDateTime(string(Obj['Created']));
  if Obj['Titel'] <> nil then
    Self.Titel := string(Obj['Titel']);
  if Obj['Art'] <> nil then
    Self.Art := string(Obj['Art']);
  if Obj['Sended'] <> nil then
    Self.Sended := StrToDateTime(string(Obj['Sended']));
end;

procedure TWaitingModel.SetValues(JSON: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(JSON);
  Self.SetValues(Obj);
end;

function TWaitingModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('ModelKind', ModelKindToStr(Self.ModelKind));
  Obj.AddPair('JobKind', JobKindToStr(Self.JobKind));
  Obj.AddPair('Value', Self.Value);
  Obj.AddPair('Created', DateTimeToStr(Self.Created));
  Obj.AddPair('Titel', Self.Titel);
  Obj.AddPair('Art', Self.Art);
  Obj.AddPair('Sended', DateTimeToStr(Self.Sended));
  Result := Obj.ToJson;
  Obj.Free;
end;

function TWaitingModel.ToPictureModel: TPictureModel;
begin
  if Self.ModelKind = mkPicture then
    Result := TPictureModel.Create(Self.Value)
  else
    Result := nil;
end;

function TWaitingModel.ToStampModel: TStampModel;
begin
  if Self.ModelKind = mkStamp then
    Result := TStampModel.Create(Self.Value)
  else
    Result := nil;
end;

constructor TWaitingModel.Create(Model: TPictureModel; JobKind: TJobKind;
  Sended: TDateTime = 0);
var
  s: string;
begin
  Self.ClearValues;
  Self.ModelKind := mkPicture;
  Self.JobKind := JobKind;
  Self.Value := Model.ToJson;
  Self.Created := Model.Created;
  Self.Titel := Model.ToString;
  s := '';
  if Model.PictureData <> '' then
    s := s + '+PNG';
  if Model.Comment <> '' then
    s := s + '+TXT';
  if s <> '' then
    Delete(s, 1, 1);
  Self.Art := s;
  Self.Sended := Sended;
end;

end.
